export const POSITION_MAPPING: { [key: string]: string } = {
	'Контролер торгового зала': 'КТЗ',
	'Работник торгового зала': 'РТЗ',
	Управляющий: 'УМ',
	'Заместитель управляющего': 'ЗУМ',
	'Продавец-кассир': 'ПК',
	'Старший кассир': 'ССК',
};

export const REGISTRATION_TYPES = {
	manual: 'ручная',
	auto: 'авто',
	outsource: 'ИСИТ',
};

export const BREACH_TYPES = {
	DiffGeo: 'Геотег',
	DiffToken: 'Нарушение авторизации',
	AnotherShift: 'Связанные авторизации',
	ErrorGeo: 'Ошибка координат',
	EndSession: 'Незакрытая сессия',
	RegManual: 'Ручная регистрация',
	PhotoError: 'Некорректное фото',
};

export const BREACH_OPTIONS = [
	{ value: 'DiffGeo', label: 'Геотег' },
	{ value: 'DiffToken', label: 'Нарушение авторизации' },
	{ value: 'AnotherShift', label: 'Связанные авторизации' },
	{ value: 'ErrorGeo', label: 'Ошибка координат' },
	{ value: 'RegManual', label: 'Ручная регистрация' },
	{ value: 'EndSession', label: 'Незакрытая сессия' },
];

export const REGISTRATION_TYPE_OPTIONS = [
	{ value: 'auto', label: 'авто' },
	{ value: 'manual', label: 'ручная' },
	{ value: 'outsource', label: 'ИСИТ' },
];

export const PER_PAGE = 10;
